export enum SeniorityLevel {
    Junior = "Junior",
    Mid = "Mid",
    Senior = "Senior",
    Lead = "Lead",
    Principal = "Principal",
    Director = "Director",
    Manager = "Manager",
    Executive = "Executive"

}